import type { Circle as CircleArea } from "../../@types/mapviewxs";
import { extractPosition } from "./helpers";
import { ACTIVE_CIRCLE_FILL_OPACITY, CIRCLE_STROKE_COLOR, CIRCLE_STROKE_WEIGHT } from "./const";
import Map = google.maps.Map;

export function drawCircle(map: Map, circleArea: CircleArea): google.maps.Circle {
  return new google.maps.Circle({
    map,
    center: extractPosition(circleArea),
    radius: circleArea.radiusInMeters,
    strokeColor: CIRCLE_STROKE_COLOR,
    strokeWeight: CIRCLE_STROKE_WEIGHT,
    fillOpacity: ACTIVE_CIRCLE_FILL_OPACITY,
    fillColor: CIRCLE_STROKE_COLOR,
    clickable: false,
  });
}
